import { useTransportMutation, useTransportQueryUtils } from "@/transport"

import type { AgentRecord } from "@/types/api/agent"

export function useDeleteAgentsTransport() {
  const queryUtils = useTransportQueryUtils()

  return useTransportMutation("deleteAgents", {
    onMutate: () => queryUtils,
    onSuccess: (response, variables, originalQueryUtils) => {
      if (!originalQueryUtils) {
        return
      }
      const requested = new Set(variables.ids)
      const deleted = new Set(
        response.results
          .filter((result) => result.success && requested.has(result.id))
          .map((result) => result.id),
      )
      for (const operation of ["listAgents", "listAllAgents"] as const) {
        originalQueryUtils.updatePaginatedOperationData(
          operation,
          (agents: AgentRecord[] | undefined) =>
            agents?.filter((agent) => !deleted.has(agent.id)),
        )
      }
    },
  })
}
